import initSelectProductOverlay from './select-product-overlay';

export default function initSubscriptions() {
  initSelectProductOverlay();
}
